// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workingHoursSettings_Rk0B8 {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.dayToggleContainer_W6ODf {
	display: flex;
	gap: 10px;
}

.saveButton_WmKgP {
	background-color: var(--_16c098-color);
	width: 140px;
	height: 40px;
	border: none;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--white-color);
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	transition: background 0.01s ease-in-out;

	&:hover {
		background: var(--_16c09821-background);
	}
}

.dayToggle_oeUBj {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.enabled_eBqiE {
	background-color: var(--_16c09821-background);
	color: var(--white-color);
}

.disabled_dN7w1 {
	background-color: #e0e0e0;
	color: var(--white-color);
}

.settingsContainer_Gk1Xg {
	display: flex;
	position: relative;
	flex-direction: column;
	gap: 7px;
}

.settingsRow_baA_4 {
	gap: 40px;
	display: flex;
	position: relative;
	color: #666;
	justify-content: space-between;
	align-items: flex-start;
	padding: 5px;
}

.dropdownContainer_W7S0S {
	position: relative;
}

.dropdownButton_GdJpM {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: row;
	width: 200px;
	color: #666;
	border-radius: 5px;
	background-color: var(--f5-background);
	padding: 0px 15px;
	height: 45px;
	border: none;
	cursor: pointer;
	gap: 8px;
}

.leftContainer_trJtO {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 14px;
	font-weight: 600;
	font-size: 14px;

	svg {
		width: 18px;
		height: 18px;
		margin-bottom: 1px;
	}
}

.leftContainerMd_OfSQt {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 14px;
	font-weight: 600;
	font-size: 14px;

	svg {
		width: 20px;
		height: 20px;
		margin-bottom: 1px;
	}
}

.arrow_AlrDC {
	width: 0;
	height: 0;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-top: 4px solid #666;
	margin-left: 8px;
	transition: transform 0.2s ease-in-out;
}

.dropdownButton_GdJpM:hover {
	background-color: var(--_16c0982e-background);
}

.dropdownMenu_pYGgw {
	position: absolute;
	overflow: hidden;
	top: 40px;
	left: 0;
	background-color: var(--f5-background);
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	z-index: 100;
	width: 200px;
}

.dropdownItem_hGANe {
	padding: 10px;
	display: flex;
	align-items: center;
	color: #666;
	font-size: 14px;
	gap: 14px;
	font-weight: 600;
	cursor: pointer;

	svg {
		width: 18px;
		height: 18px;
		margin-bottom: 1px;
	}
}

.columnTitle_zgeJx {
	color: #333 !important;
	font-size: 11px !important;
	font-weight: 700 !important;
	width: 200px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	padding: 0px 15px;
	margin-bottom: -12px;

	svg {
		margin-left: 8px;
		margin-bottom: 1px;
		width: 19px;
		height: 19px;
	}
}

.columnTitleHour_ADkkf {
	color: #333 !important;
	font-size: 11px !important;
	font-weight: 700 !important;
	width: 310px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	padding-left: 110px;
	margin-bottom: -12px;
}

.dropdownItem_hGANe:hover {
	background-color: var(--_16c0982e-background);
}

.copyButton_e_ufw {
	position: absolute;
	right: -200px;
	display: flex;
	align-items: center;
	top: 40px;
	cursor: pointer;
	gap: 5px;
	color: var(--_16c09821-background);
	font-size: 14px;
}


.copyButton_e_ufw:hover {
	text-decoration: underline;
}


.hoursWrapper_5dDlc {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.singleHourContainer_aAa4y {
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
	width: 75px;
}

.hoursContainer_MxkwY {
	display: flex;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	position: relative;
	align-items: center;
	justify-content: space-between;
	height: 45px;
	width: 200px;
	font-weight: 600;
	color: #666;
	font-size: 14px;
	border-radius: 5px;
	background-color: var(--f5-background);
}

.minusButton_gExla {
	position: absolute;
	right: -280px;
	display: flex;
	align-items: center;
	top: 10px;
	cursor: pointer;
	color: #666;
	font-size: 20px;
	width: 20px;
	height: 20px;
	transition: background 0.01s ease-in-out;

	&:hover {
		color: #444;
	}
}

.minusButtonRight_MVAOH {
	position: absolute;
	right: -310px;
	display: flex;
	align-items: center;
	top: 10px;
	cursor: pointer;
	color: #666;
	font-size: 20px;
	width: 20px;
	height: 20px;
	transition: background 0.01s ease-in-out;

	&:hover {
		color: #444;
	}
}

.plusButton_tN9i9 {
	position: absolute;
	right: -280px;
	display: flex;
	align-items: center;
	top: 10px;
	cursor: pointer;
	color: #666;
	font-size: 20px;
	width: 20px;
	height: 20px;
	transition: background 0.01s ease-in-out;

	&:hover {
		color: #444;
	}
}

.leftWrapper_ZLNK7 {
	display: flex;
	align-items: flex-start;
	width: 310px;
	justify-content: space-between;
	gap: 40px;
}


.timeDropdown_I51Ny {
	position: absolute;
	top: 35px;
	left: 0;
	background-color: var(--f5-background);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	z-index: 100;
	display: flex;
	flex-direction: column;
	max-height: 350px;
	overflow: hidden;
	padding: 8px;
}

.timeDropdownRight_D5lvn {
	position: absolute;
	top: 35px;
	right: 0;
	background-color: var(--f5-background);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	z-index: 100;
	display: flex;
	flex-direction: column;
	max-height: 350px;
	overflow: hidden;
	padding: 8px;
}

.period_qJrUT {
	font-weight: bold;
	font-size: 12px;
	display: flex;
	text-align: center;
	margin-bottom: 5px;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;

	div {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		-webkit-user-select: none;
		        user-select: none;
		width: 40%;
		padding: 2px;
		border-radius: 2px;
		background: var(--f5-background);

		&:hover {
			background: var(--_16c0982e-background);
		}
	}
}

.timeDropdownItem_CGceL {
	display: flex;
	flex-direction: column;
	cursor: pointer;
	width: 50px;
	text-align: center;
	max-height: 100px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}

	-ms-overflow-style: none;
	scrollbar-width: none;
}

.dropdownItem_hGANe {
	padding: 10px;
	cursor: pointer;
}

.hoursDropdownItem_Ap5ZT {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	margin: 1px;
}

.hoursDropdownItem_Ap5ZT:hover {
	background-color: var(--_16c0982e-background);
}

.dropdownItem_hGANe:hover {
	background-color: var(--_16c0982e-background);
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/WorkingHoursSettings.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,sCAAsC;CACtC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;CACf,yBAAyB;CACzB,iBAAiB;CACjB,wCAAwC;;CAExC;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,6CAA6C;CAC7C,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,SAAS;CACT,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,8BAA8B;CAC9B,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,sCAAsC;CACtC,iBAAiB;CACjB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,gBAAgB;CAChB,eAAe;;CAEf;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,gBAAgB;CAChB,eAAe;;CAEf;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD;;AAEA;CACC,QAAQ;CACR,SAAS;CACT,kCAAkC;CAClC,mCAAmC;CACnC,0BAA0B;CAC1B,gBAAgB;CAChB,sCAAsC;AACvC;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,OAAO;CACP,sCAAsC;CACtC,2CAA2C;CAC3C,kBAAkB;CAClB,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,eAAe;CACf,SAAS;CACT,gBAAgB;CAChB,eAAe;;CAEf;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD;;AAEA;CACC,sBAAsB;CACtB,0BAA0B;CAC1B,2BAA2B;CAC3B,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;;CAEpB;EACC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;CACb;AACD;;AAEA;CACC,sBAAsB;CACtB,0BAA0B;CAC1B,2BAA2B;CAC3B,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,QAAQ;CACR,kCAAkC;CAClC,eAAe;AAChB;;;AAGA;CACC,0BAA0B;AAC3B;;;AAGA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,WAAW;CACX,eAAe;CACf,WAAW;CACX,YAAY;CACZ,wCAAwC;;CAExC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,WAAW;CACX,eAAe;CACf,WAAW;CACX,YAAY;CACZ,wCAAwC;;CAExC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,WAAW;CACX,eAAe;CACf,WAAW;CACX,YAAY;CACZ,wCAAwC;;CAExC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,YAAY;CACZ,8BAA8B;CAC9B,SAAS;AACV;;;AAGA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,sCAAsC;CACtC,wCAAwC;CACxC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,sCAAsC;CACtC,wCAAwC;CACxC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,8BAA8B;;CAE9B;EACC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;;EAEhC;GACC,uCAAuC;EACxC;CACD;AACD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;;CAEhB;EACC,aAAa;CACd;;CAEA,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,6CAA6C;AAC9C","sourcesContent":[".workingHoursSettings {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n}\n\n.dayToggleContainer {\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.saveButton {\n\tbackground-color: var(--_16c098-color);\n\twidth: 140px;\n\theight: 40px;\n\tborder: none;\n\tborder-radius: 4px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--white-color);\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\tuser-select: none;\n\ttransition: background 0.01s ease-in-out;\n\n\t&:hover {\n\t\tbackground: var(--_16c09821-background);\n\t}\n}\n\n.dayToggle {\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n}\n\n.enabled {\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--white-color);\n}\n\n.disabled {\n\tbackground-color: #e0e0e0;\n\tcolor: var(--white-color);\n}\n\n.settingsContainer {\n\tdisplay: flex;\n\tposition: relative;\n\tflex-direction: column;\n\tgap: 7px;\n}\n\n.settingsRow {\n\tgap: 40px;\n\tdisplay: flex;\n\tposition: relative;\n\tcolor: #666;\n\tjustify-content: space-between;\n\talign-items: flex-start;\n\tpadding: 5px;\n}\n\n.dropdownContainer {\n\tposition: relative;\n}\n\n.dropdownButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-direction: row;\n\twidth: 200px;\n\tcolor: #666;\n\tborder-radius: 5px;\n\tbackground-color: var(--f5-background);\n\tpadding: 0px 15px;\n\theight: 45px;\n\tborder: none;\n\tcursor: pointer;\n\tgap: 8px;\n}\n\n.leftContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 14px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tmargin-bottom: 1px;\n\t}\n}\n\n.leftContainerMd {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 14px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-bottom: 1px;\n\t}\n}\n\n.arrow {\n\twidth: 0;\n\theight: 0;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-top: 4px solid #666;\n\tmargin-left: 8px;\n\ttransition: transform 0.2s ease-in-out;\n}\n\n.dropdownButton:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.dropdownMenu {\n\tposition: absolute;\n\toverflow: hidden;\n\ttop: 40px;\n\tleft: 0;\n\tbackground-color: var(--f5-background);\n\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\tborder-radius: 5px;\n\tz-index: 100;\n\twidth: 200px;\n}\n\n.dropdownItem {\n\tpadding: 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: #666;\n\tfont-size: 14px;\n\tgap: 14px;\n\tfont-weight: 600;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tmargin-bottom: 1px;\n\t}\n}\n\n.columnTitle {\n\tcolor: #333 !important;\n\tfont-size: 11px !important;\n\tfont-weight: 700 !important;\n\twidth: 200px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tpadding: 0px 15px;\n\tmargin-bottom: -12px;\n\n\tsvg {\n\t\tmargin-left: 8px;\n\t\tmargin-bottom: 1px;\n\t\twidth: 19px;\n\t\theight: 19px;\n\t}\n}\n\n.columnTitleHour {\n\tcolor: #333 !important;\n\tfont-size: 11px !important;\n\tfont-weight: 700 !important;\n\twidth: 310px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tpadding-left: 110px;\n\tmargin-bottom: -12px;\n}\n\n.dropdownItem:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.copyButton {\n\tposition: absolute;\n\tright: -200px;\n\tdisplay: flex;\n\talign-items: center;\n\ttop: 40px;\n\tcursor: pointer;\n\tgap: 5px;\n\tcolor: var(--_16c09821-background);\n\tfont-size: 14px;\n}\n\n\n.copyButton:hover {\n\ttext-decoration: underline;\n}\n\n\n.hoursWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.singleHourContainer {\n\tdisplay: flex;\n\tposition: relative;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 75px;\n}\n\n.hoursContainer {\n\tdisplay: flex;\n\tcursor: pointer;\n\tuser-select: none;\n\tposition: relative;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: 45px;\n\twidth: 200px;\n\tfont-weight: 600;\n\tcolor: #666;\n\tfont-size: 14px;\n\tborder-radius: 5px;\n\tbackground-color: var(--f5-background);\n}\n\n.minusButton {\n\tposition: absolute;\n\tright: -280px;\n\tdisplay: flex;\n\talign-items: center;\n\ttop: 10px;\n\tcursor: pointer;\n\tcolor: #666;\n\tfont-size: 20px;\n\twidth: 20px;\n\theight: 20px;\n\ttransition: background 0.01s ease-in-out;\n\n\t&:hover {\n\t\tcolor: #444;\n\t}\n}\n\n.minusButtonRight {\n\tposition: absolute;\n\tright: -310px;\n\tdisplay: flex;\n\talign-items: center;\n\ttop: 10px;\n\tcursor: pointer;\n\tcolor: #666;\n\tfont-size: 20px;\n\twidth: 20px;\n\theight: 20px;\n\ttransition: background 0.01s ease-in-out;\n\n\t&:hover {\n\t\tcolor: #444;\n\t}\n}\n\n.plusButton {\n\tposition: absolute;\n\tright: -280px;\n\tdisplay: flex;\n\talign-items: center;\n\ttop: 10px;\n\tcursor: pointer;\n\tcolor: #666;\n\tfont-size: 20px;\n\twidth: 20px;\n\theight: 20px;\n\ttransition: background 0.01s ease-in-out;\n\n\t&:hover {\n\t\tcolor: #444;\n\t}\n}\n\n.leftWrapper {\n\tdisplay: flex;\n\talign-items: flex-start;\n\twidth: 310px;\n\tjustify-content: space-between;\n\tgap: 40px;\n}\n\n\n.timeDropdown {\n\tposition: absolute;\n\ttop: 35px;\n\tleft: 0;\n\tbackground-color: var(--f5-background);\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tz-index: 100;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 350px;\n\toverflow: hidden;\n\tpadding: 8px;\n}\n\n.timeDropdownRight {\n\tposition: absolute;\n\ttop: 35px;\n\tright: 0;\n\tbackground-color: var(--f5-background);\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tz-index: 100;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 350px;\n\toverflow: hidden;\n\tpadding: 8px;\n}\n\n.period {\n\tfont-weight: bold;\n\tfont-size: 12px;\n\tdisplay: flex;\n\ttext-align: center;\n\tmargin-bottom: 5px;\n\tflex-direction: row;\n\twidth: 100%;\n\tjustify-content: space-between;\n\n\tdiv {\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tuser-select: none;\n\t\twidth: 40%;\n\t\tpadding: 2px;\n\t\tborder-radius: 2px;\n\t\tbackground: var(--f5-background);\n\n\t\t&:hover {\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t}\n\t}\n}\n\n.timeDropdownItem {\n\tdisplay: flex;\n\tflex-direction: column;\n\tcursor: pointer;\n\twidth: 50px;\n\ttext-align: center;\n\tmax-height: 100px;\n\toverflow-y: auto;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n}\n\n.dropdownItem {\n\tpadding: 10px;\n\tcursor: pointer;\n}\n\n.hoursDropdownItem {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 3px;\n\tmargin: 1px;\n}\n\n.hoursDropdownItem:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.dropdownItem:hover {\n\tbackground-color: var(--_16c0982e-background);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workingHoursSettings": `workingHoursSettings_Rk0B8`,
	"dayToggleContainer": `dayToggleContainer_W6ODf`,
	"saveButton": `saveButton_WmKgP`,
	"dayToggle": `dayToggle_oeUBj`,
	"enabled": `enabled_eBqiE`,
	"disabled": `disabled_dN7w1`,
	"settingsContainer": `settingsContainer_Gk1Xg`,
	"settingsRow": `settingsRow_baA_4`,
	"dropdownContainer": `dropdownContainer_W7S0S`,
	"dropdownButton": `dropdownButton_GdJpM`,
	"leftContainer": `leftContainer_trJtO`,
	"leftContainerMd": `leftContainerMd_OfSQt`,
	"arrow": `arrow_AlrDC`,
	"dropdownMenu": `dropdownMenu_pYGgw`,
	"dropdownItem": `dropdownItem_hGANe`,
	"columnTitle": `columnTitle_zgeJx`,
	"columnTitleHour": `columnTitleHour_ADkkf`,
	"copyButton": `copyButton_e_ufw`,
	"hoursWrapper": `hoursWrapper_5dDlc`,
	"singleHourContainer": `singleHourContainer_aAa4y`,
	"hoursContainer": `hoursContainer_MxkwY`,
	"minusButton": `minusButton_gExla`,
	"minusButtonRight": `minusButtonRight_MVAOH`,
	"plusButton": `plusButton_tN9i9`,
	"leftWrapper": `leftWrapper_ZLNK7`,
	"timeDropdown": `timeDropdown_I51Ny`,
	"timeDropdownRight": `timeDropdownRight_D5lvn`,
	"period": `period_qJrUT`,
	"timeDropdownItem": `timeDropdownItem_CGceL`,
	"hoursDropdownItem": `hoursDropdownItem_Ap5ZT`
};
export default ___CSS_LOADER_EXPORT___;
